import { LoadableLazy } from '@confluence/loadable';
export { PagePublishAutomationDiscoveryDialog } from '../src/PagePublishAutomationDiscoveryDialog';
export const LazyPagePublishAutomationDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PagePublishAutomationDiscoveryDialog" */ '../src/PagePublishAutomationDiscoveryDialog'
			)
		).PagePublishAutomationDiscoveryDialog,
});
